import { render, staticRenderFns } from "./akuntansi.vue?vue&type=template&id=3d3f3e0e&scoped=true"
import script from "./akuntansi.vue?vue&type=script&lang=js"
export * from "./akuntansi.vue?vue&type=script&lang=js"
import style0 from "./akuntansi.vue?vue&type=style&index=0&id=3d3f3e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3f3e0e",
  null
  
)

export default component.exports